export default class MultiFormatDownloadsRespPreview {
    constructor(name, id, argTokenDetailsIdListForPreview) {
      this.name = name;
      this.id = id;
      this.argTokenDetailsIdListForPreview = argTokenDetailsIdListForPreview;  
    }
}